<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Bienvenido {{getUser.firstName}}</h1>
        </div>
        <div class="ctn_general dashboard_boxed_color">

            <div class="DashCards x4 flex">
                <div class="DashCardTitleBox">
                    <h4>Ingresos estimados</h4>
                </div>
                <div class="DashCardsContentBox">
                    <div class="DashCardsItem">
                        <h5>Hoy</h5>
                        <h6 v-pen="data.todayAmount"></h6>
                        <p>{{ getOrdersLabel(data.todayOrders) }}</p>
                    </div>
                    <div class="DashCardsItem">
                        <h5>Ayer</h5>
                        <h6 v-pen="data.yesterdayAmount"></h6>
                        <p>{{ getOrdersLabel(data.yesterdayOrders) }}</p>
                    </div>
                    <div class="DashCardsItem">
                        <h5>Últimos 7 días</h5>
                        <h6 v-pen="data.lastWeekAmount"></h6>
                        <p>{{ getOrdersLabel(data.lastWeekOrders) }}</p>
                    </div>
                    <div class="DashCardsItem">
                        <h5>Este mes</h5>
                        <h6 v-pen="data.currentMonthAmount"></h6>
                        <p>{{ getOrdersLabel(data.currentMonthOrders) }}</p>
                    </div>
                </div>
            </div>

            <div class="DashCards x1 flex">
                <div class="DashCardTitleBox">
                    <h4>Saldo</h4>
                </div>
                <div class="DashCardsContentBox">
                    <div class="DashCardsItem">
                        <h5>Mes anterior</h5>
                        <h6 v-pen="data.lastMonthAmount"></h6>
                        <p>{{ getOrdersLabel(data.lastMonthOrders) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import DailySummaryService from "../services/DailySummaryService";
    import {mapGetters} from 'vuex'

    export default {
        components: {},
        data() {
            return {
                data: {}
            }
        },
        computed: {
            ...mapGetters([
                'getUser'
            ]),
        },
        methods: {
            getOrdersLabel: function (orders) {
                return orders + " pedido" + (orders === 1 ? '' : 's');
            }
        },
        async mounted() {
            this.data = (await DailySummaryService.getSummary()).data.payload;

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue